import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AspectRatioImage } from 'src/components/shared/AspectRatioImage';
import { getHouseType } from 'src/lib/getHouseType';
import { Construction } from 'src/models/resort/Construction';
import { UserColor } from 'src/models/resort/UserColor';
import { FamilyIcon } from '../common/FamilyIcon';
import { NpcIcons } from '../common/NpcIcons';
import { getConstructionTheme } from './ConstructionTheme';
import { FacilityIcon } from './FacilityIcon';

interface ResortConstructionItemProps {
  construction: Construction;
  userColor: UserColor;
}

export const ResortConstructionItem: React.FC<ResortConstructionItemProps> = ({
  construction,
  userColor
}) => {
  const { t } = useTranslation('resort');
  let iconHeader: JSX.Element | null;
  switch (construction.structureKind) {
    case 0:
      const houseType = getHouseType(construction.npcs);
      iconHeader =
        houseType === 'normal' ? (
          <NpcIcons npcs={construction.npcs} iconSize={40} />
        ) : (
          <FamilyIcon family={houseType} iconHeight={40} />
        );
      break;
    case 1:
      iconHeader = <FacilityIcon facilityId={construction.facilityId} iconSize={40} />;
      break;
    default:
      iconHeader = null;
  }

  const constructionTheme = getConstructionTheme(t, construction);
  const imageSrc = construction.resortImages[0];

  return (
    <div
      className={css`
        position: relative;
        text-align: center;
        border-radius: 2px;
        background: ${userColor.main};
        padding: 3px;
        .icon-container {
          position: absolute;
          top: -16px;
          left: 0;
          right: 0;
        }
        .image {
          background: white;
          img {
            height: auto;
          }
        }
        .label {
          color: ${userColor.text};
          font-size: 12px;
          min-height: 1rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-top: 4px;
        }
      `}
    >
      <div className="image">
        <AspectRatioImage src={imageSrc} width={960} height={540} />
      </div>
      <div className="icon-container">{iconHeader}</div>
      <p className="label">{constructionTheme}</p>
    </div>
  );
};
